import React from 'react';
import { useModalContext } from '@fiverr-private/overlay';
import { Alert } from '@fiverr-private/orca';
import { I18n } from '@fiverr-private/i18n-react';
import { useSupportChat } from '../../hooks';
import { MODAL_TRANSLATIONS_KEY } from './SendMessageModal';

export const OpeningHours = () => {
    const { close } = useModalContext();
    const { isChatAvailable, toggleChat } = useSupportChat();

    const onImmediateAssistanceClick = () => {
        close?.();
        if (isChatAvailable) {
            toggleChat();
        }
    };

    return (
        <Alert
            text={
                <span style={{ color: 'inherit', fontSize: '14px' }}>
                    <I18n k={`${MODAL_TRANSLATIONS_KEY}.operating_hours`} /> <br />
                    <I18n
                        k={`${MODAL_TRANSLATIONS_KEY}.immediate_assistance`}
                        templates={{
                            link: (text) => (
                                <span
                                    style={{ cursor: 'pointer', textDecoration: 'underline', fontWeight: 600 }}
                                    onClick={onImmediateAssistanceClick}
                                >
                                    {text}
                                </span>
                            ),
                        }}
                    />
                </span>
            }
            // @ts-expect-error orca types are missing theme
            theme={Alert.THEMES.INFORMATION}
        />
    );
};
